import { Outlet } from 'react-router-dom';
import { Box } from '@mantine/core';

export function ExamLayout() {
  return (
    <Box mih="100vh">
      <Outlet />
    </Box>
  );
}
